import { createWebHistory, createRouter } from 'vue-router';
import { getLocaleFromURL } from './locale.js';

import Home from './components/home.vue';
// import users_create from './components/user/create.vue';
// import users_edit from './components/user/edit.vue';
// import users_show from './components/user/show.vue';
import addresses_index from './components/address/index.vue';
// import addresses_create from './components/address/create.vue';
// import addresses_edit from './components/address/edit.vue';
import products_index from './components/product/index.vue';
import products_show from './components/product/show.vue';
// import categories_index from './components/category/index.vue';
// import occasions_index from './components/occasion/index.vue';
// import occasions_show from './components/occasion/show.vue';
// import suppliers_index from './components/supplier/index.vue';
import orders_index from './components/order/index.vue';
// import orders_create from './components/order/create.vue';
import orders_show from './components/order/show.vue';
// import order_items_index from './components/order_item/index.vue';
// import order_items_create from './components/order_item/create.vue';
// import coupons_create from './components/coupon/create.vue';
import cart_items_index from './components/cart_item/index.vue';
import checkout_index from './components/cart_item/checkout.vue';
// import cart_items_create from './components/cart_item/create.vue';
// import cart_items_edit from './components/cart_item/edit.vue';
// import reviews_index from './components/review/index.vue';
// import reviews_create from './components/review/create.vue';
// import return_requests_index from './components/return_request/index.vue';
// import return_requests_create from './components/return_request/create.vue';
// import return_requests_show from './components/return_request/show.vue';
// import contacts_data_index from './components/contact_data/index.vue';
import pages_show from './components/page/show.vue';
import contact_us_create from './components/contact_u/create.vue';
// import socials_index from './components/social/index.vue';
import faqs_index from './components/faq/index.vue';
// import sliders_index from './components/slider/index.vue';
import users_edit from './components/auth/edit.vue';

import Activation from './components/auth/Activation';
import Register from './components/auth/Register';
import Login from './components/auth/Login';
import user_password_reset from './components/auth/passwordReset.vue';
import user_password_change from './components/auth/passwordChange.vue';

import users_change_password from './components/auth/changePassword.vue';

const routes =  [
    {
        name: 'home',
        // path: '/',
        path: '/:lang?', // Make the language segment optional by adding "?" after ":lang"
        component: Home
    },
    {
        name: 'register',
        path: '/:lang?/register',
        component: Register
    },
    {
        name: 'activation',
        path: '/:lang?/activation',
        component: Activation
    },
    {
        name: 'login',
        path: '/:lang?/login',
        component: Login
    },
    {
        "name": "password.reset",
        "path": "/:lang?/password/reset",
        "component": user_password_reset
    },
    {
        "name": "password.change",
        "path": "/:lang?/password/change",
        "component": user_password_change
    },
    {
        "name": "users.change_password",
        "path": "/:lang?/users/change_password",
        "component": users_change_password
    },
    // {
    //     name: 'users.create',
    //     path: '/:lang?/users/create',
    //     component: users_create,
    // },
    // {
    //     name: 'users.edit',
    //     path: '/:lang?/users/:id/edit',
    //     component: users_edit,
    // },
    // {
    //     name: 'users.show',
    //     path: '/:lang?/users/:id',
    //     component: users_show,
    // },
    {
        "name": "users.edit",
        "path": "/:lang?/users/edit",
        "component": users_edit
    },
    {
        name: 'addresses.index',
        path: '/:lang?/addresses',
        component: addresses_index,
    },
    // {
    //     name: 'addresses.create',
    //     path: '/:lang?/addresses/create',
    //     component: addresses_create,
    // },
    // {
    //     name: 'addresses.edit',
    //     path: '/:lang?/addresses/:id/edit',
    //     component: addresses_edit,
    // },
    {
        name: 'products.index',
        path: '/:lang?/products',
        component: products_index,
    },
    {
        "name": "products.show",
        "path": "/:lang?/products/:id",
        "component": products_show
    },
    // {
    //     "name": "categories.index",
    //     "path": "/:lang?/categories",
    //     "component": categories_index
    // },
    // {
    //     "name": "occasions.index",
    //     "path": "/:lang?/occasions",
    //     "component": occasions_index
    // },
    // {
    //     "name": "occasions.show",
    //     "path": "/:lang?/occasions/:id",
    //     "component": occasions_show
    // },
    // {
    //     "name": "suppliers.index",
    //     "path": "/:lang?/suppliers",
    //     "component": suppliers_index
    // },
    {
        "name": "orders.index",
        "path": "/:lang?/orders",
        "component": orders_index
    },
    // {
    //     "name": "orders.create",
    //     "path": "/:lang?/orders/create",
    //     "component": orders_create
    // },
    {
        "name": "orders.show",
        "path": "/:lang?/orders/:id",
        "component": orders_show
    },
    // {
    //     "name": "order_items.index",
    //     "path": "/:lang?/order_items",
    //     "component": order_items_index
    // },
    // {
    //     "name": "order_items.create",
    //     "path": "/:lang?/order_items/create",
    //     "component": order_items_create
    // },
    // {
    //     "name": "coupons.create",
    //     "path": "/:lang?/coupons/create",
    //     "component": coupons_create
    // },
    {
        "name": "cart_items.index",
        "path": "/:lang?/cart_items",
        "component": cart_items_index
    },
    {
        "name": "checkout",
        "path": "/:lang?/checkout",
        "component": checkout_index
    },
    // {
    //     "name": "cart_items.create",
    //     "path": "/:lang?/cart_items/create",
    //     "component": cart_items_create
    // },
    // {
    //     "name": "cart_items.edit",
    //     "path": "/:lang?/cart_items/:id/edit",
    //     "component": cart_items_edit
    // },
    // {
    //     "name": "reviews.index",
    //     "path": "/:lang?/reviews",
    //     "component": reviews_index
    // },
    // {
    //     "name": "reviews.create",
    //     "path": "/:lang?/reviews/create",
    //     "component": reviews_create
    // },
    // {
    //     "name": "return_requests.index",
    //     "path": "/:lang?/return_requests",
    //     "component": return_requests_index
    // },
    // {
    //     "name": "return_requests.create",
    //     "path": "/:lang?/return_requests/create",
    //     "component": return_requests_create
    // },
    // {
    //     "name": "return_requests.show",
    //     "path": "/:lang?/return_requests/:id",
    //     "component": return_requests_show
    // },
    // {
    //     "name": "contacts_data.index",
    //     "path": "/:lang?/contacts_data",
    //     "component": contacts_data_index
    // },
    // {
    //     "name": "socials.index",
    //     "path": "/:lang?/socials",
    //     "component": socials_index
    // },
    {
        name: 'pages.show',
        path: '/:lang?/pages/:id', // Add the language segment before "/pages/:id"
        component: pages_show,
    },
    {
        name: 'contact_us.create',
        path: '/:lang?/contact_us/create', // Add the language segment before "/contact_us/create"
        component: contact_us_create,
    },
    {
        name: 'faqs.index',
        path: '/:lang?/faqs', // Add the language segment before "/faqs"
        component: faqs_index,
    },
    // {
    //     "name": "sliders.index",
    //     "path": "/sliders",
    //     "component": sliders_index
    // },
] ;

const router = createRouter({
    history: createWebHistory(),
    routes,
});


// Global navigation guard
// router.beforeEach((to, from, next) => {
//     const lang = getLocaleFromURL();
//     console.log(lang);
//     to.params.lang = lang;
//
//     console.log(to.params);
//     next();
// });


// router.beforeEach((to, from, next) => {
//     if (to.query.reload) {
//         window.location.reload();
//     } else {
//         next();
//     }
// });

export default router;
